import { defineStore } from 'pinia'
import { useShopsStore } from '@/stores/Shops.store'
import {
  printSpecs,
  printTemplates,
  securePrintSpecs,
  securePrintTemplates
} from './PrintSpecs'
import { getShop, getDeliveryDates } from '@/api/api'
import { getPrintSpecs, getProductSpecs } from './PrintOrderApi'

export const usePrintOrderStore = defineStore('printOrder', {
  state: () => ({
    orderDetails: {
      instruction: '',
      deliveryAddress: {},
      invoiceAddress: {},
      letter: '',
      deliveryDate: {},
      orderType: 'deliver',
      secure: false,
      quotationNo: '',
      project: {
        id: 0,
        name: ''
      },
      reference: '',
      externalId: ''
    },
    printSpecs: printSpecs,
    printSpecsSecure: securePrintSpecs,
    printTemplates: printTemplates,
    printTemplatesSecure: securePrintTemplates,
    shop: {},
    dates: [],
    orderErrors: []
  }),
  persist: {
    storage: sessionStorage,
    pick: ['orderDetails']
  },
  actions: {
    addOrderError(error) {
      if (!this.orderErrors.includes(error)) {
        this.orderErrors.push(error)
      }
    },
    removeOrderError(error) {
      this.orderErrors = this.orderErrors.filter((e) => e !== error)
    },
    updateOrderDetails(spec, value) {
      this.orderDetails[spec] = value
    },
    updateProject(proj) {
      this.orderDetails.project = {
        name: proj.name || '',
        id: proj.id || 0
      }
    },
    resetOrderDetails() {
      this.shop = {}
      this.dates = []
      this.orderErrors = []
      this.orderDetails = {
        instruction: '',
        deliveryAddress: {},
        invoiceAddress: {},
        letter: '',
        deliveryDate: {},
        orderType: 'deliver',
        secure: false,
        quotationNo: '',
        project: {
          id: 0,
          name: ''
        },
        reference: '',
        externalId: ''
      }
    },
    setPrintSpecs(specs) {
      this.printSpecs = specs
    },
    setPrintTemplates(specs) {
      this.printTemplates = specs
    },
    setPrintTemplatesSecure(specs) {
      this.printTemplatesSecure = specs
    },
    updateShop(shop) {
      this.shop = shop
    },
    updateDates(dates) {
      this.dates = dates
    },
    hydratePrintSpecs(val) {
      getPrintSpecs(val).then((response) => {
        this.setPrintSpecs(response)
      })
    },
    hydratePrintSpecsSecured(val) {
      getPrintSpecs(val).then((response) => {
        this.printSpecsSecure = response
      })
    },
    hydratePrintTemplates(val) {
      getProductSpecs(val).then((response) => {
        this.setPrintTemplates(response)
      })
    },
    hydratePrintTemplatesSecure(val) {
      getProductSpecs(val).then((response) => {
        this.setPrintTemplatesSecure(response)
      })
    },
    getTheDates(val) {
      return new Promise((resolve, reject) => {
        getDeliveryDates(val.shopId, val.invoiceId, val.secure).then((resp) => {
          this.updateDates(resp)
          resolve(resp)
        })
      })
    },
    getTheShop(val) {
      const shopsStore = useShopsStore()
      getShop(val.deliveryAddress, val.invoiceId, val.secure).then((resp) => {
        const shop =
          shopsStore.shopsList.find((shop) => resp.location?.id === shop.id) ||
          {}
        this.updateShop(shop)
      })
    }
  }
})
